import { ApiClientProps } from "hooks/useApi";
import { environment } from "utilities/constants"; // Update the path to match the correct location of the constants file

export interface GetOAuthTokenResponse {
  accessToken: string;
  message: string;
}

interface GetOAuthToken {
  locationId: string | undefined;
  partnerId: string | undefined;
  apiClient: ApiClientProps;
  posType: string | undefined;
}


async function getOAuthToken({
  locationId,
  partnerId,
  apiClient,
  posType,
}: GetOAuthToken): Promise<GetOAuthTokenResponse | undefined> {
  const { isValidOnboardingPos } = environment;

  if (posType && !isValidOnboardingPos.includes(posType)) {
    return;
  }


  if (!locationId || !partnerId) {
    throw new Error(
      "Network failure. Please check your connection and ensure your request includes all required parameters."
    );
  }

  const path = `/middleware-admin/partners/${partnerId}/locations/${locationId}/${posType}/oauth/token`;

  try {
    const response = await apiClient.get({
      path,
      noRetry: true,
    });

    if (!response) {
      return;
    }

    return response.resource;
  } catch (error) {
    throw new Error(error as string);
  }
}

export default getOAuthToken;
